import React, { useEffect } from "react";

const HubSpotChatAnonymous = () => {
    useEffect(() => {
        if (!window.HubSpotConversations) return;
      
        window.hsConversationsSettings = {
          loadImmediately: true,
        };
      
        if (window.HubSpotConversations.widget) {
          window.HubSpotConversations.widget.load(); // 👈 this is essential
        } else {
          window.hsConversationsOnReady = window.hsConversationsOnReady || [];
          window.hsConversationsOnReady.push(() => {
            window.HubSpotConversations.widget.load();
          });
        }
      }, []);

  return null;
};

export default HubSpotChatAnonymous;
